// Impressum und Datenschutz auf jedem Bildschirm (ein Klick).

import { AGB_VERBRAUCHER_URL, DATENSCHUTZ_URL, IMPRESSUM_URL } from "@umzugsscan/shared";

/** privat: Kunden-Version (Vertrag mit Umzugsscan) → auch die Verbraucher-AGB. */
export function RechtLinks({ privat = false }: { privat?: boolean }) {
  return (
    <footer className="recht">
      <div>
        <a className="marke-fuss" href="https://umzugsscan.app" target="_blank" rel="noopener">
          <img src="/umzugsscan-logo.svg" alt="Umzugsscan" />
        </a>
      </div>
      <a href={IMPRESSUM_URL} target="_blank" rel="noopener">
        Impressum
      </a>
      <span aria-hidden="true"> · </span>
      <a href={DATENSCHUTZ_URL} target="_blank" rel="noopener">
        Datenschutz
      </a>
      {privat && (
        <>
          <span aria-hidden="true"> · </span>
          <a href={AGB_VERBRAUCHER_URL} target="_blank" rel="noopener">
            AGB
          </a>
        </>
      )}
    </footer>
  );
}
